import { render } from "./expired-products.vue?vue&type=template&id=28d25731"
import script from "./expired-products.vue?vue&type=script&lang=js"
export * from "./expired-products.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__